var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12896_47270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 68,
    r: 47,
    stroke: "#D1D5DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 68,
    r: 36,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 7,
    width: 16,
    height: 8,
    rx: 4,
    stroke: "#D1D5DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 16,
    width: 2,
    height: 4,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.22 38.0421C22.7772 35.5994 22.7772 31.6389 25.22 29.1962C27.6627 26.7535 31.6231 26.7535 34.0658 29.1962L35.1728 30.3031L26.3269 39.149L25.22 38.0421Z",
    stroke: "#D1D5DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.366 38.0421C105.809 35.5994 105.809 31.6389 103.366 29.1962C100.923 26.7535 96.9628 26.7535 94.5201 29.1962L93.4132 30.3031L102.259 39.149L103.366 38.0421Z",
    stroke: "#D1D5DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 68,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 48,
    width: 2,
    height: 17,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 40,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 96,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 88,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 88,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 68,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 68,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 48,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 48,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.856 125.589L80.8628 114.082C80.6132 113.992 80.4096 113.807 80.2966 113.567C80.1836 113.327 80.1705 113.052 80.2603 112.802L94.475 73.281C94.5648 73.0314 94.75 72.8277 94.99 72.7147C95.2299 72.6017 95.5049 72.5887 95.7545 72.6784L117.948 80.661L124.826 95.2647L114.136 124.986C114.046 125.236 113.861 125.44 113.621 125.553C113.381 125.666 113.106 125.679 112.856 125.589Z",
    fill: "white",
    stroke: "#D1D5DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68 79.8604L115.295 89.2702C115.116 89.7693 115.142 90.3193 115.368 90.7992C115.594 91.2791 116.001 91.6495 116.5 91.8291L125.91 95.2135L118.68 79.8604Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.995 112.869L91.1754 106.1C90.9258 106.01 90.6508 106.023 90.4109 106.136C90.1709 106.249 89.9857 106.453 89.8959 106.703C89.8062 106.952 89.8192 107.227 89.9322 107.467C90.0452 107.707 90.2489 107.892 90.4985 107.982L109.318 114.751C109.568 114.841 109.843 114.828 110.083 114.715C110.323 114.602 110.508 114.398 110.598 114.149C110.687 113.899 110.674 113.624 110.561 113.384C110.448 113.144 110.245 112.959 109.995 112.869Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.378 103.459L94.5582 96.69C94.3086 96.6002 94.0336 96.6133 93.7937 96.7263C93.5537 96.8393 93.3685 97.043 93.2787 97.2925C93.189 97.5421 93.202 97.8171 93.315 98.0571C93.428 98.297 93.6317 98.4822 93.8813 98.572L112.701 105.341C112.951 105.431 113.226 105.418 113.465 105.305C113.705 105.192 113.891 104.988 113.98 104.738C114.07 104.489 114.057 104.214 113.944 103.974C113.831 103.734 113.627 103.549 113.378 103.459Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.469 89.9879L97.941 87.2803C97.6914 87.1906 97.4164 87.2036 97.1765 87.3166C96.9365 87.4296 96.7513 87.6333 96.6616 87.8829C96.5718 88.1324 96.5848 88.4074 96.6978 88.6474C96.8108 88.8873 97.0145 89.0726 97.2641 89.1623L104.792 91.8699C105.042 91.9596 105.317 91.9466 105.556 91.8336C105.796 91.7206 105.982 91.5169 106.071 91.2673C106.161 91.0178 106.148 90.7428 106.035 90.5028C105.922 90.2629 105.718 90.0777 105.469 89.9879Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12896_47270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.fe31b7f5.svg";
export { ForwardRef as ReactComponent };